// client/src/components/tendermaker/ReviewWidget.js
import React, { useState } from "react";
import { tmSubmitReview } from "./tendermakerApi";

export default function ReviewWidget({ docId, runId, extracted }) {
  const [rating, setRating] = useState("5");
  const [notes, setNotes] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  async function submit() {
    setBusy(true);
    setErr("");
    try {
      await tmSubmitReview({
        docId,
        runId,
        rating: Number(rating),
        notes,
        correctedJson: null, // later we’ll allow edit + submit corrected JSON
      });
      setDone(true);
    } catch (e) {
      setErr(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ marginTop: 12, borderTop: "1px solid #f3f4f6", paddingTop: 12 }}>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Review (Learning from Day 1)</div>

      <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
        <label>
          Rating:
          <select value={rating} onChange={(e) => setRating(e.target.value)} style={{ marginLeft: 8 }}>
            <option value="5">5 (Excellent)</option>
            <option value="4">4 (Good)</option>
            <option value="3">3 (Okay)</option>
            <option value="2">2 (Poor)</option>
            <option value="1">1 (Wrong)</option>
          </select>
        </label>
      </div>

      <textarea
        placeholder="What was wrong? What should be added/removed? Any buyer-specific clause we missed?"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={4}
        style={{ width: "100%", padding: 10, borderRadius: 8, border: "1px solid #e5e7eb" }}
      />

      {err ? <div style={{ color: "crimson", marginTop: 8 }}>{err}</div> : null}
      {done ? <div style={{ color: "green", marginTop: 8 }}>Saved. Thank you — this improves the engine.</div> : null}

      <button
        onClick={submit}
        disabled={busy}
        style={{ marginTop: 10, padding: "10px 14px", borderRadius: 10, border: "1px solid #e5e7eb" }}
      >
        {busy ? "Saving…" : "Submit Review"}
      </button>
    </div>
  );
}
